/* t7-2a remate 2 (#529): LA CAJA DEL ICONO DE UN MATERIAL, compartida por el Panel del alumno
   y el banco del profe.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Tres iconos, los del banco (C4): documento (la hoja), video de YouTube y audio (el
   microfono). LAPIDA t7-2b (E4, Carlos 27-sep): el video era el logo de YouTube de lucide (el
   rectangulo redondeado con el triangulo); ahora es la camara de video (`Video`), porque Carlos
   decidio no usar el logo. El rotulo sigue diciendo "Video de YouTube". El tipo lo decide
   `lib/tipoDeMaterial.js`; aqui solo se pinta. La caja lleva un rotulo para el lector de
   pantalla (`common:a11y.material.*`), y por eso recibe `t` del que la monta: el Panel
   traduce con su propio gancho y el banco con el suyo, y este componente no depende de
   ninguno.

   El `tamano` elige la caja y el trazo de cada lugar SIN mover un pixel de lo que ya habia:
     banco       40 x 40, radio 10, icono de 16 gris (la caja de C4);
     movil       la caja de la gemela movil de toda tarjeta del Panel (C6), icono de 16 naranja;
     escritorio  la caja de la gemela de escritorio (C6), icono de 16 (20 desde md) naranja.

   Las dos cajas del Panel (C6) viven AQUI desde este remate, una sola copia por gemela;
   `TarjetaDeCard.js` las re-exporta con el mismo nombre, asi que el grupo, la padre y el Panel
   las siguen importando de alli. */
import React from 'react';
import { FileText, Mic, Video } from 'lucide-react';

// ajustes-1-3-0 (Bloque C6, ajuste 10): la caja del icono de TODA tarjeta de la lista del Panel
// (documento, grupo, documento partido, cada parte, la bloqueada): fondo #0f0f0f y borde de
// 1 px #2a2a2a, con el radio de cada gemela.
export const CAJA_DEL_ICONO_MOVIL = 'w-8 h-8 rounded-lg bg-[#0f0f0f] border border-[#2a2a2a] flex items-center justify-center shrink-0';
export const CAJA_DEL_ICONO_ESCRITORIO = 'w-9 h-9 md:w-10 md:h-10 rounded-xl bg-[#0f0f0f] border border-[#2a2a2a] flex items-center justify-center shrink-0';
// t7-2a (C4): la caja del banco del profe (el radio de 10 va en linea, como en C4).
export const CAJA_DEL_ICONO_BANCO = 'shrink-0 inline-flex items-center justify-center w-10 h-10 bg-[#0f0f0f] border border-[#2a2a2a]';

export const TAMANOS_DEL_ICONO = {
  banco: { etiqueta: 'span', caja: CAJA_DEL_ICONO_BANCO, estilo: { borderRadius: 10 }, trazo: 'w-4 h-4 text-[#a0a0a0]' },
  movil: { etiqueta: 'div', caja: CAJA_DEL_ICONO_MOVIL, estilo: undefined, trazo: 'w-4 h-4 text-[#FF6B00]' },
  escritorio: { etiqueta: 'div', caja: CAJA_DEL_ICONO_ESCRITORIO, estilo: undefined, trazo: 'w-4 h-4 md:w-5 md:h-5 text-[#FF6B00]' },
};

const ICONOS = { documento: FileText, youtube: Video, audio: Mic };

// El rotulo de cada tipo para el lector de pantalla (ES y EN en `common.json`, bajo `a11y`,
// junto al de la X de las ventanas).
export const ROTULO_DEL_TIPO = {
  documento: 'common:a11y.material.documento',
  youtube: 'common:a11y.material.youtube',
  audio: 'common:a11y.material.audio',
};

/* t7-2b (E3, pendiente 13): EL GLIFO DEL TIPO SIN CAJA, para las cabeceras que pintaban una
   hoja suelta (la pagina de temas del profe y la lista y el detalle de Analiticas). El mismo
   mapa de tres iconos que la caja, sin la caja ni el rotulo: el que lo monta pone el tamano y
   el color que ya tenia su hoja, y el glifo sigue siendo decorativo (el nombre del archivo va
   al lado), como la hoja que habia: solo recibe la clase, asi que lucide le pone su
   `aria-hidden` de siempre y un documento se pinta byte a byte como antes. Un tipo
   desconocido cae en la hoja. */
export function GlifoDeMaterial({ tipo, className }) {
  const cual = ICONOS[tipo] ? tipo : 'documento';
  const Icono = ICONOS[cual];
  return <Icono className={className} />;
}

export default function IconoDeMaterial({ tipo, tamano = 'banco', t, testid }) {
  const cual = ICONOS[tipo] ? tipo : 'documento';
  const medida = TAMANOS_DEL_ICONO[tamano] || TAMANOS_DEL_ICONO.banco;
  const Icono = ICONOS[cual];
  const Caja = medida.etiqueta;
  return (
    <Caja className={medida.caja} style={medida.estilo} role="img"
      aria-label={typeof t === 'function' ? t(ROTULO_DEL_TIPO[cual]) : undefined}
      data-testid={testid} data-tipo={cual}>
      <Icono className={medida.trazo} aria-hidden="true" />
    </Caja>
  );
}
